import { ConditionalComponentProps } from '@/types/other';

export default function ConditionalComponent({
  condition,
  trueComponent,
  falseComponent,
}: ConditionalComponentProps) {
  return condition ? trueComponent : falseComponent;
}
